import { React, useState } from "react";

const useDatepicker = () => {
  const today = new Date();
  const options = { day: "numeric", month: "long", year: "numeric" };
  const formattedDate = today.toLocaleDateString("en-GB", options);

  const [datepicker, setDatePicker] = useState(formattedDate);

  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const formattedSelectedDate = selectedDate.toLocaleDateString("en-GB", options);
    setDatePicker(formattedSelectedDate);
  };

  return { datepicker, handleDateChange };
};

export default useDatepicker;